import React, { useState } from "react";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import { activateOrganization } from "../../data/organization-store";

function ActivateOrgButton(props) {
  const { organizationId, onShowSnackbar } = props;
  const [activating, setActivating] = useState(false);

  const handleClick = async () => {
    setActivating(true);

    try {
      await activateOrganization(organizationId);

      onShowSnackbar({
        open: true,
        message: "Organization activated.",
        severity: "success",
        autoHideDuration: 6000,
      });
    } catch (error) {
      onShowSnackbar({
        open: true,
        message: "Failed to reactivate organization.",
        severity: "error",
        error: error,
      });
    } finally {
      setActivating(false);
    }
  };

  return (
    <React.Fragment>
      <Tooltip title="Activate Organization" aria-label="activate organization">
        {activating ? (
          <CircularProgress size={24} />
        ) : (
          <Button aria-label="activate organization" onClick={handleClick}>
            ACTIVATE
          </Button>
        )}
      </Tooltip>
    </React.Fragment>
  );
}

ActivateOrgButton.propTypes = {
  organizationId: PropTypes.string,
  onShowSnackbar: PropTypes.func,
};

export default ActivateOrgButton;
